// extracted by mini-css-extract-plugin
export var bannerBox = "grid-module--banner-box--U-yte";
export var grid = "grid-module--grid--perEY";
export var pulse = "grid-module--pulse--D+H1d";
export var scrollButton = "grid-module--scroll-button--QwoS5";
export var scrollButtonLine = "grid-module--scroll-button-line--VO50M";
export var scrollButtonText = "grid-module--scroll-button-text--IKwxI";
export var small = "grid-module--small--+yZ2F";